<template>
  <admin-wrapper
    title-translation-path="admin.waterModeling"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :hasButtons="false"
  >
    <template #tabs.input>
      <grey-tabs v-model="tab" :tabs="tabs" has-border cols="auto">
        <v-tab-item>
          <modeling-results-ranges-settings type="water" />
        </v-tab-item>
        <v-tab-item>
          <admin-wrapper
            title-translation-path="admin.epanetLabels"
            :inputs="epanetInputs"
            @save="save"
            @setPayloadValue="setPayload"
            disable-sticky-buttons
          />
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import GreyTabs from '@/components/GreyTabs';
import ModelingResultsRangesSettings from '@/components/ModelingResultsRangesSettings';
export default {
  name: 'WaterModelingSettings',
  components: {
    AdminWrapper,
    GreyTabs,
    ModelingResultsRangesSettings,
  },
  computed: {
    epanetTags: get('admin/settingsValues@epanet_tags_format'),
    epanetTagsArray() {
      return Object.keys(this.epanetTags);
    },
    epanetInputs() {
      return this.epanetTagsArray.map(tag => ({
        isCustom: true,
        name: 'epanet_tags_format',
        valueSubproperty: tag,
        translationPath: `admin.${tag}`,
        dataType: {
          name: 'text',
        },
      }));
    },
    moduleEnabler() {
      return {
        name: 'water_modeling_module_enabled',
        translationPath: 'admin.waterModeling',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.waterModeling') }),
      };
    },
    inputs() {
      return [
        {
          name: 'tabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    tabs() {
      return [{ name: this.$i18n.t('admin.modelingResultsBrowser') }, { name: 'EPANET' }];
    },
  },
  data: () => ({
    tab: 0,
  }),
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    async save() {
      try {
        this.$root.$emit('adminSavingON');
        await this.editSingleSetting({
          key: 'epanet_tags_format',
          body: {
            value: this.payload,
          },
        });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
        this.$root.$emit('adminSavingOFF');
      } catch (error) {
        this.$root.$emit('adminSavingOFF');
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.settingChangeFailed'),
        });
        console.log(error);
      }
    },
    setPayload({ value, subproperty }) {
      this.payload = { ...this.payload, [subproperty]: value };
    },
  },
};
</script>
